import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import * as _ from 'lodash';
import { catchError, finalize, forkJoin, map } from 'rxjs';
import { Cassette } from 'src/app/domain/cassette';
import { EActivitySimulationType } from 'src/app/domain/enums/activity-simulation-type';
import { EAPRType } from 'src/app/domain/enums/APR-type';
import { EBuildingType } from 'src/app/domain/enums/building-type';
import { EEntreeZoneType } from 'src/app/domain/enums/entree-zone';
import { EEPIType } from 'src/app/domain/enums/epi-type';
import { EIntegriteType } from 'src/app/domain/enums/integrite-type';
import { EInterventionStatus } from 'src/app/domain/enums/intervention-status';
import { EMasterDataType } from 'src/app/domain/enums/master-data-type';
import { EMesureTerrainStatus } from 'src/app/domain/enums/mesure-terrrain-status';
import { EMeteoType } from 'src/app/domain/enums/meteo-type';
import { EPostureType } from 'src/app/domain/enums/posture-type';
import { ERoomUsage } from 'src/app/domain/enums/room-usage';
import { ESamplingMode } from 'src/app/domain/enums/sampling-mode';
import { ESiteType } from 'src/app/domain/enums/site-type';
import { ESubSection } from 'src/app/domain/enums/subsection';
import { ETetePrelevement } from 'src/app/domain/enums/tete-prelevement';
import { ETimeSlot } from 'src/app/domain/enums/time-slot';
import { EVentilationGlobaleType } from 'src/app/domain/enums/ventilation-global-type';
import { EZoneType } from 'src/app/domain/enums/zone-type';
import { EZoneUsage } from 'src/app/domain/enums/zone-usage';
import { GlobalTask } from 'src/app/domain/global-task';
import { Intervention } from 'src/app/domain/intervention';
import { MeanOfPrevention } from 'src/app/domain/mean-of-prevention';
import { MPCA } from 'src/app/domain/mpca';
import { Operator } from 'src/app/domain/operator';
import { PlageHoraire } from 'src/app/domain/plage-horaire';
import { Pompe } from 'src/app/domain/pompe';
import { Process } from 'src/app/domain/process';
import { ProcessCalculation } from 'src/app/domain/process-calculation';
import { ProcessMeasure } from 'src/app/domain/process-mesure';
import { ProcessSamplingCondition } from 'src/app/domain/process-sampling-condition';
import { ProcessTechnique } from 'src/app/domain/process-technique';
import { PointageJournalier } from 'src/app/domain/RH/pointage-journalier';
import { PointagePause } from 'src/app/domain/RH/pointage-pause';
import { Securite } from 'src/app/domain/securite';
import { Task } from 'src/app/domain/task';
import { User } from 'src/app/domain/user';
import { Zone } from 'src/app/domain/zone';
import { ZoneMeasure } from 'src/app/domain/zone-measure';
import { ZoneSamplingCondition } from 'src/app/domain/zone-sampling-condition';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { InterventionService } from 'src/app/services/intervention.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { ColorService } from 'src/app/tools/ui/color.service';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { environment } from 'src/environments/environment';
import { db } from '../../db/db';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from '../base/base.component';

@Component({
    selector: 'app-intervention-list',
    templateUrl: './intervention-list.component.html',
    styleUrls: ['./intervention-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InterventionListComponent extends BaseComponent implements OnInit {
    EInterventionStatus = EInterventionStatus;
    InterventionList: Intervention[] = [];

    get IsDevelopment() {
        return environment.name === 'DEV';
    }

    constructor(
        protected override coreData: CoreData,
        private interventionService: InterventionService,
        private masterDataService: MasterDataService,
        private snackBar: MatSnackBar,
        private router: Router,
        public loadingTask: LoadingTask,
        private dialog: MatDialog) {
        super(coreData);
    }

    async ngOnInit(): Promise<void> {

        this.coreData.CurrentPageName = "Mes Interventions";
        // new Intervention({Code: "INT000002", PlannedOn: Temporal.Now.plainDateISO().add({hours: 1}), Sampler:  user, ZPList: [], SamplingPoint: { Name: 'La Gross Riviere', City: 'Berge', ZipCode: '93100', AddressLine1: '2 Rue du bouc'}, StrategyId: 2});
        // new Intervention({Code: "INT000004", PlannedOn: Temporal.Now.plainDateISO().add({hours: 7}), Sampler: user, ZPList: [], SamplingPoint: { Name: 'La Gross Riviere', City: 'Berge', ZipCode: '93100', AddressLine1: '2 Rue du bouc'}, StrategyId: 3});
        // new Intervention({Code: "INT000003", PlannedOn: Temporal.Now.plainDateISO().add({hours: 2}), Sampler: user, ZPList: [], SamplingPoint: { Name: 'La Gross Riviere', City: 'Berge', ZipCode: '93100', AddressLine1: '2 Rue du bouc'}, StrategyId: 4});
        // new Intervention({Code: "INT000005", PlannedOn: Temporal.Now.plainDateISO().add({hours: 4}), Sampler:  user, ZPList: [], SamplingPoint: { Name: 'La Gross Riviere', City: 'Berge', ZipCode: '93100', AddressLine1: '2 Rue du bouc'}, StrategyId: 5});
        await this.getInterventionListFromLocalDB();
    }

    getColor() {
        return ColorService.getRandomPastelColor();
    }

    reset() {
        this.interventionService.getMyIntervention().subscribe(async x => {

            await db.resetDatabase();
            for (let i = 0, y: Intervention; y = x[i]; i++) {
                await db.addIntervention(y);
            }
            await this.getInterventionListFromLocalDB();
        })
    }

    getMyIntervention() {
        if (this.loadingTask.IsLoading) {
            NotificationManager.handleSuccess('Merci de patienter !', this.snackBar);
            return;
        }
        const dialogRef = this.dialog.open(ConfirmBoxDialog, { data: { message: 'Etes-vous sûr de vouloir récupérer les nouvelles interventions ?', withCancelButton: true } });
        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                forkJoin([
                    this.interventionService.getMyIntervention(),
                    this.masterDataService.getMasterDataByType(EMasterDataType.ScolaMaterial),
                    this.masterDataService.getMasterDataByType(EMasterDataType.Catchment),
                    this.masterDataService.getMasterDataByType(EMasterDataType.Humidification),
                    this.masterDataService.getMasterDataByType(EMasterDataType.HumidityWork),
                    this.masterDataService.getMasterDataByType(EMasterDataType.ScolaTechnique),
                    this.masterDataService.getMasterDataByType(EMasterDataType.OnSiteProtectionAndSealingType)
                ]).subscribe(async ([intList, Sm, C, H, Hw, St]) => {
                    // Sm, C, H, Hw, St ARE HERE JUST FOR NETWORK CACHING FOR THE MOMENT. BUT MAYBE IN DB IN THE FUTURE
                    this.loadingTask.activateLoading();
                    await this.getInterventionListFromLocalDB()

                    // Remove intervention that from the past days if they are done
                    for (let i = 0, int = null; i < this.InterventionList.length; i++) {
                        int = this.InterventionList[i];
                        if (Temporal.PlainDate.compare(int.PlannedOn, (Temporal.Now.plainDateISO())) === -1) {
                            await db.deleteIntervention(int.Code);
                        }
                    }

                    const diff: Intervention[] = _.differenceBy(intList, this.InterventionList, x => x.Code);
                    if (diff && diff.length > 0) {
                        for (let i = 0; i < diff.length; i++) {
                            await db.addIntervention(diff[i]);
                        }
                    }
                    await this.getInterventionListFromLocalDB();
                    this.loadingTask.deactivateLoading();
                    NotificationManager.handleSuccess('Récupération des interventions terminée !', this.snackBar);
                })
            }
        });
    }

    async getInterventionListFromLocalDB() {
        this.InterventionList = await db.getInterventionList();
        this.InterventionList = _.sortBy(this.InterventionList, x => this.convertTemporalToDate(x.PlannedOn))
    }

    async getInterventionListFromMockedData() {
        await db.resetDatabase();

        const user = new User();
        user.Email = 'toto@eurofins.com';
        user.FirstName = 'to';
        user.LastName = 'to';
        user.Phone = '0611223344';

        const int = new Intervention({
            Code: 1,
            Status: EInterventionStatus.New,
            TimeSlotPlannedOn: ETimeSlot.afternoon,
            PlannedOn: Temporal.Now.plainDateTimeISO(),
            Sampler: user,
            SamplingPoint: {
                Code: 'SP1',
                Name: 'La Gross Riviere',
                City: 'Berge',
                ZipCode: '93100',
                Address: '2 Rue du bouc'
            }
        })

        const zone1 = new Zone({
            Code: 'Zone000001',
            ActivitySimulation: EActivitySimulationType.RemiseEnSuspension,
            BuildingType: EBuildingType.Educational,
            CustomerReference: 'REFREF',
            Position: 1,
            Type: EZoneType.Indoor,
            RoomUsage: ERoomUsage.Evacuated,
            Usage: EZoneUsage.PreWork

        });
        const mpca1 = new MPCA({ Code: 'MPCA1', Name: 'Poudre', ScolaMaterial: 'CHocolat' });
        const mpca2 = new MPCA({ Code: 'MPCA2', Name: 'Poudre de lait', ScolaMaterial: 'Fraise' });
        zone1.MpcaList.push(mpca1);
        zone1.MpcaList.push(mpca2);
        const m1 = new ZoneMeasure({ Code: 'ZM00001', MeasureReferenceCode: 'G', MeasureReferenceName: 'G', Status: EMesureTerrainStatus.Pose, Color: 'FF0000', TextColor: '000000' });
        const m2 = new ZoneMeasure({ Code: 'ZM00002', MeasureReferenceCode: 'U', MeasureReferenceName: 'U', Status: EMesureTerrainStatus.Recupere, Color: 'FFFF00', TextColor: '000000' });
        const cassette = new Cassette({ Reference: 'K7', TypeTetePrelevement: ETetePrelevement.Cathia, Integrite: EIntegriteType.Oui, RefTetePrelevement: 'TETET' });
        const horaireList: PlageHoraire[] = [];
        horaireList.push({ Debut: Temporal.Now.plainDateTimeISO(), Fin: Temporal.Now.plainDateTimeISO().add({ hours: 1 }), Color: ColorService.getRandomPastelColor() });
        horaireList.push({ Debut: Temporal.Now.plainDateTimeISO().add({ hours: 2 }), Fin: Temporal.Now.plainDateTimeISO().add({ hours: 3 }), Color: ColorService.getRandomPastelColor() });
        horaireList.push({ Debut: Temporal.Now.plainDateTimeISO().add({ hours: 4 }), Fin: Temporal.Now.plainDateTimeISO().add({ hours: 5 }), Color: ColorService.getRandomPastelColor() });
        cassette.PlageHoraireList.push(...horaireList);
        m1.Cassette = cassette;
        const pompe = new Pompe({ CompteurHoraireFinal: 1, CompteurHoraireInitial: 2, DebitInitial: 3, DebitFinal: 4, ElectriciteAccessible: true, Reference: 'Pompope', CompteurVolFinal: 100, CompteurVolInitial: 80 });
        cassette.Pompe = pompe;
        const securitePose = new Securite({ DureeExposition: 1, Epi: 3, EntreeZone: 1 });
        const securiteDePose = new Securite({ DureeExposition: 2, Epi: 2, EntreeZone: 2 });
        m1.PoseSecurite = securitePose;
        m1.DeposeSecurite = securiteDePose;
        const sc = new ZoneSamplingCondition({ Hygrometrie: 2, Meteo: 4, VitesseVent: 5 });
        m1.ZoneSamplingCondition = sc;

        zone1.ZoneMesureList.push(m1);
        zone1.ZoneMesureList.push(m2);
        const zone2 = new Zone({
            Code: 'Zone000002',
            ActivitySimulation: EActivitySimulationType.MaintienEnSuspension,
            BuildingType: EBuildingType.Industrial,
            CustomerReference: 'REFREF123',
            Position: 2,
            Type: EZoneType.Indoor,
            RoomUsage: ERoomUsage.LivingRoom,
            Usage: EZoneUsage.Environmental
        });

        const process = new Process({ Code: 'PROPRO', CustomerReference: 'SHITREF', DustLevel: 'bpc', DustLoadType: 2, Name: 'Proc', SubSection: ESubSection.SubSection3, VentilationGlobale: EVentilationGlobaleType.DispositifHorsFonction, Type: ESiteType.PreparatoryWork })
        process.ProcessCalculation = new ProcessCalculation({ Duration: 33, SamplingMode: ESamplingMode.Simultaneous });

        process.EnvCollectiveMeansOfPreventionList.push(new MeanOfPrevention({ Name: 'Casque' }));
        process.EnvCollectiveMeansOfPreventionList.push(new MeanOfPrevention({ Name: 'Gant' }));
        process.EnvCollectiveMeansOfPreventionList.push(new MeanOfPrevention({ Name: 'Bouclier' }));
        const technique = new ProcessTechnique({ Catchment: 'FEf', Humidification: 'sec', HumidityWork: 'mouillu', ScolaTechnique: 'tektek', Mpca: mpca1 });
        process.ProcessTechniqueList.push(technique);

        const m3 = new ProcessMeasure({ Code: 'ZM00002', MeasureReferenceCode: 'J', MeasureReferenceName: 'J', Status: EMesureTerrainStatus.Recupere, Color: 'FFFF00', TextColor: '000000' });
        process.TaskList.push(new GlobalTask({ Position: 1, Description: 'ewfwfe' }))
        process.TaskList.push(new GlobalTask({ Position: 2, Description: 'gerg erg' }))
        process.TaskList.push(new GlobalTask({ Position: 3, Description: 'ewf fdgd fgfdwfe' }))
        process.TaskList.push(new GlobalTask({ Position: 4, Description: 'ewfw4heg erg erg ergfe' }))

        const op1 = new Operator({ FirstName: 'Jean-Michel', LastName: 'Amoitie' });
        op1.TaskList.push(new Task({ Description: 'voir', Position: 1, Posture: EPostureType.AGenoux, StartedOn: Temporal.Now.plainDateTimeISO(), EndedOn: Temporal.Now.plainDateTimeISO(), Repetitif: true }));
        op1.TaskList.push(new Task({ Description: 'boir', Position: 1, Posture: EPostureType.Accroupi, StartedOn: Temporal.Now.plainDateTimeISO(), EndedOn: Temporal.Now.plainDateTimeISO(), Repetitif: false }));
        op1.TaskList.push(new Task({ Description: 'noir', Position: 1, Posture: EPostureType.Couche, StartedOn: Temporal.Now.plainDateTimeISO(), EndedOn: Temporal.Now.plainDateTimeISO(), Repetitif: true }));

        const op2 = new Operator({ FirstName: 'Jean-Michel', LastName: 'ApeuPres' });
        const cond = new ProcessSamplingCondition({ Apr: EAPRType.AdductionAirALaDemande, Hygrometrie1: 2, Hygrometrie2: 3, Hygrometrie3: 5, Meteo: EMeteoType.Brumeux, VitesseVent1: 1, VitesseVent2: 2, VitesseVent3: 3 });
        m3.ProcessSamplingCondition = cond;
        m3.ProcessOperatorList.push(op1);
        m3.ProcessOperatorList.push(op2);
        m3.Securite = new Securite({ Epi: EEPIType.AdductionFP250, DureeExposition: 2, EntreeZone: EEntreeZoneType.Sas })
        process.ProcessMesure = m3;

        int.ZoneList.push(zone1);
        int.ZoneList.push(zone2);
        int.ProcessList.push(process);

        const intId = await db.addIntervention(int);

        const pointage = new PointageJournalier({
            DebutJournee: Temporal.Now.plainDateTimeISO(), FinJournee: Temporal.Now.plainDateTimeISO(),
            PointagePauseList: [new PointagePause({
                Debut: Temporal.Now.plainDateTimeISO(),
                Fin: Temporal.Now.plainDateTimeISO()
            }), new PointagePause({
                Debut: Temporal.Now.plainDateTimeISO(),
                Fin: Temporal.Now.plainDateTimeISO()
            })]
        })

        await db.addPointageJournalier(pointage);
    }

    refreshSpecificIntervention(event: Event, int: Intervention) {
        event.preventDefault();
        event.stopPropagation();
        const dialogRef = this.dialog.open(ConfirmBoxDialog, { data: { message: 'Etes-vous sûr de vouloir recharger cette intervention, ce qui n\'est pas sauvegardé sera perdu', withCancelButton: true } });
        dialogRef.afterClosed().subscribe(async (result: boolean) => {
            if (result) {

                this.interventionService.geInterventionByCode(int.Code).subscribe(async (x: Intervention) => {
                    this.loadingTask.activateLoading();
                    await db.deleteIntervention(int.Code);
                    await db.addIntervention(x);
                    // await this.getInterventionListFromLocalDB();
                    this.loadingTask.deactivateLoading();
                    NotificationManager.handleSuccess('Intervention mise à jour', this.snackBar);
                });
            }
        })
    }

    navigatoToIntervention(code: number, samplingPointName: string) {
        if (this.loadingTask.IsLoading > 0) {
            return;
        }
        this.coreData.CurrentPageName = samplingPointName;
        this.router.navigate([ENavigationRoute.Intervention, { interventionCode: code }])
    }

    getColorByInterventionIndex(index: number) {

        switch (index) {
            case 2:
                return "cadetblue !important";
            case 3:
                return "seagreen !important";
            case 4:
                return "red !important";
        }
        return "grey";
    }

    // async getStaticPumpWithBattery(code: number) {
    //     let int = await db.getInterventionByCode(code);
    //     return int.ZoneList.filter(x => x.ZoneMesureList.map(y => y.PumpWithBattery === true));
    // }

    // async getStaticPumpWithPowerSupply(code: number) {
    //     let int = await db.getInterventionByCode(code);
    //     return int.ZoneList.filter(x => x.ZoneMesureList.map(y => y.PumpWithBattery === false));
    // }

    // async getPumpOnOperator(code: number) {
    //     let int = await db.getInterventionByCode(code);
    //     return int.ProcessList.map(x => x.ProcessMesure.ProcessOperatorList.map(y => y.CassetteList.map(z => z.Pompe))).flat(2).length;
    // }

    // async setInterventionAsFinished(event: Event, int: Intervention) {
    //     event.preventDefault();
    //     event.stopPropagation();

    //     this.sync(int);
    // }

    openPlanDeSituation(event: Event, data: string) {
        event.stopPropagation();
        // var image = new Image();
        // image.src = (<HTMLInputElement>document.getElementById("idimage")).src;

        var w = window.open('', '_blank');
        if (w) {
            w.document.write(`<img src="data:image/jpeg;base64,${data}">`);
            w.document.close();
        }

    }

    sync(int: Intervention, event?: Event, withDoneHandler?: boolean) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (withDoneHandler) {
            int.Status = EInterventionStatus.Done;
        }
        this.interventionService.syncIntervention(int)
            .pipe(
                catchError((err: any) => {
                    if (withDoneHandler) {
                        int.Status = EInterventionStatus.Validated;
                    }
                    throw err
                    // return of(0);
                }),
                finalize(() => this.loadingTask.deactivateLoading()),
                map(x => x))
            .subscribe(
                async (x: any) => {
                    NotificationManager.handleSuccess('Intervention sauvegardée', this.snackBar);
                    if (withDoneHandler) {
                        await db.changeInterventionStatus(int);
                    }
                });
    }

}
